
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Þetta er gert með
                    <a href="${0}">Folksonomy Engine verkefninu</a>. Ekki hika við að taka þátt eða gefa ábendingar
`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Þetta tól gerir þér kleift að leiðrétta innihaldslistann. Þú getur bætt við, fjarlægt eða breytt
                innihaldslistanum.
                <br>
                Þessi stafur <span class="highlight">␣</span> táknar bil.
                <br>
                Þessi stafur <span class="highlight">↩︎</span> táknar línuskipti. `,
'hb28f1f2ec1744ee9': html`These properties are created and filed by users for any kind of usages. Feel
                    free to add your own. The properties and values you create
                    <strong>must be factual</strong>. You can dive into
                    <a href="${0}">the list of properties already used by the community</a>
                    or explore the
                    <a href="${1}">properties' documentation and its search engine</a>.`,
's000a5b76bd3a01c2': `Hleður inn eiginleikum...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Hjálpið okkur að fá hráefni`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Staðfesta uppskeru`,
's03e9c8114521b998': `Ég mun breyta innihaldsefnunum`,
's05ec315d9308091a': `Táknmynd fyrir horn strikamerkja`,
's061eb5af92512c85': `Vistað! Geturðu aðstoðað með annað?`,
's06847c221c4c0bc1': `Mig langar að búa til eiginleika til að [lýsa notkunartilviki þínu]...`,
's06f6c6f99db6b552': `Upprunalega`,
's081e2ad82db71e1d': `Flokkuð gildi`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `sérstök skjöl`,
's0bb2d48532acc455': `Sækja CSV-skrá`,
's0d5b7fee0311db68': `Eign`,
's0fb218abc2e157ed': `Ógilda mynd`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Hætta við skurð`,
's11a18a69b30b65ed': `Hjálpaðu okkur að leiðrétta villur í innihaldslistanum`,
's1205d5f6fccf8e69': `Verðmæti eignar`,
's15d64a0a6715285a': `Nýr lykill`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Valsvæði`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Hjálpaðu okkur að leiðrétta næringarupplýsingarnar`,
's1e00019dc454872d': `Vinsamlegast gefðu upp eiginleikaheiti með því að nota eiginleikann property-name.`,
's1e49126af0935a5b': `Listi yfir vörur sem nota þessa eiginleika`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `Skjalfesta eignina`,
's300b3a6ee4e1252d': str`Léleg samsvörun ${0}%`,
's33f786bb6b4f0cf4': `Uppskeruárangur`,
's33f85f24c0f5f008': `Save`,
's34be4af4e8fec4ae': `Spyrjið samfélagið fyrst`,
's36d86adc823cbfa6': `Áður en ný eign er stofnuð skal ræða hana við samfélagið:`,
's3781d25aa51a736c': `Skjölun á Folksonomy vélinni`,
's383ae4449428b61e': `Endurstilla skurð`,
's39bcf88721a1e8ee': `Endurstilla val`,
's39e14e14300694c7': `Skjölun og leiðbeiningar`,
's3b430cfa5c1fe7f4': str`Gögn fyrir ${0}`,
's3f4e4b52f230a892': `Myndstrigi`,
's417b90913e05bc17': `Forskoðun`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Miðjumynd`,
's42dd66b2441566fd': `Miðjutákn`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Bætið við næringarefni`,
's453ab0dbb9b5c777': `Breyta stærð til hægri`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Vörufjöldi`,
's4df2f533c0c1e7d0': `Myndstýringar`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Færa val`,
's4f751fb9b3ed766c': `Að búa til nýja eign`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Sláðu inn nafn eignar...`,
's55d7249883a98ca1': `um þessa eign á Open Food Facts wiki`,
's565867d84c04aea2': `Sía eiginleika...`,
's5666afe5cd0166de': `Vinsamlegast leiðréttu villurnar eða breyttu textanum áður en þú staðfestir`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Hleður vörur...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Hjálpaðu okkur að leiðrétta næringarupplýsingarnar.`,
's5dd6f12783fca34f': `Breyta innihaldslista`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Takk fyrir framlag þitt!`,
's6cee7cad81dfedd1': `Skerð mynd`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Góð samsvörun ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Skjölun`,
's787dd11bed0dc88a': `Breyta stærð til vinstri`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `Frekari upplýsingar um stofnun eigna og leiðbeiningar:`,
's8038273de2cf8b73': `Veldu svæði til að klippa.`,
's839cc2908a5387f2': `Sía strikamerki...`,
's86197dcf3e96af64': `Skoða og leita að núverandi eignum`,
's8a63be30a129a59c': `Breyta stærð neðst`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Breyta stærð efst til hægri`,
's8db84aa4bc949af2': `Skjalfesta nýju eignina`,
's8f839a03997a16d7': `Skoða vöru`,
's901ae1e236ac45d3': `Hætta við eyðingu`,
's907f7a97c6b29425': `Hafðu í huga að gagnalíkanið gæti breyst. Notkun á eigin ábyrgð.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Innihaldsefni:`,
's9a7f60fce090ecaf': `Mistókst að hlaða inn eiginleikum. Reyndu aftur síðar.`,
's9b87abd68fb9df45': `Finnst ekki? Búa til nýjan lykil {value}`,
's9c0f52425fd2f07e': `Getur ekki passað`,
's9fc41f789c63b40d': `Vörur`,
'sa1fa766e0d5634d7': `Engin stig tiltæk`,
'sa548778b24054030': `Skoðaðu alla eiginleika sem hafa verið lagðir til úr Folksonomy Engine verkefninu. Þessir eiginleikar veita frekari lýsigögn og innsýn í vörur í gagnagrunninum Open Food Facts.`,
'sa63907958bd0ec4b': `Breyta stærð efst til vinstri`,
'sa95b4224f685a36a': `Loka stillingu`,
'sab56a1d439576fd6': `Tillögutákn`,
'sac47ea2901d04c15': `Breyta stærð neðst til vinstri`,
'sb125227d436c2925': `Leitaðu að hugmyndinni um fasteign þína í núverandi fasteignagrunni:`,
'sb125568d43642e6f': `Svaraðu spurningum um vöruna.`,
'sb1c538e038f9b214': str`Mjög góð samsvörun ${0}%`,
'sb28639570ff3b852': `listi yfir allar eignir`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Þegar þú hefur staðfest að eignin þín sé ekki til og samfélagið samþykkir að hún sé gagnleg, þarftu fyrst að skrá hana á wiki-síðunni.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Engar vörur fundust fyrir þessa eign.`,
'sb7f72e4c8a2d3357': `Sía gildi...`,
'sb8178320160f84ea': `Sýna uppskeru`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Öllum innsýnum hefur verið svarað! Takk fyrir hjálpina!`,
'sbd9a0b2293b3cd3c': `Skammtastærð`,
'sbe472dc3c2685985': `Samsvarandi gildi`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Breyta stærð efst`,
'sc1c08d0cbcc3bd24': `Passar ekki saman`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Tillögur að lagfæringu`,
'sc681b137e8f604f7': `Staðfesta eyðingu`,
'sc6daf8a31883f8b9': `Færa mynd`,
'sc895972c88d38ca5': `Folksonomy eign`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Raðir`,
'scb3b0671d7b7f640': `Nýtt gildi`,
'scb489a1a173ac3f0': `Yes`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Taktu þátt í Slack-umræðunni`,
'scdb6cad0b92721bf': `Engar eignir fundust.`,
'scf23a05631f93732': `Staðfesta eyðingu`,
'scfed2f270ef6a3aa': `Veldu svæði`,
'sd1022bc1ef9204f7': `Aðdráttarhæf mynd`,
'sd1077c055cf9ba6b': `Hjálpaðu okkur að staðfesta innihaldslýsingu vörunnar.`,
'sd698d21ddecba56b': `Hæ! Þú getur hjálpað okkur að bæta vöruupplýsingarnar með því að svara eftirfarandi spurningum:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Athuga hvort eign sé þegar til staðar`,
'sdbf806fefc584115': `Þú ættir að finna`,
'sdc673e73b5c13aea': `Eyða`,
'sdc792b75f1edcaba': `Hjálpaðu okkur að leiðrétta stafsetningu innihaldsefna.`,
'sdca5deead576ceee': `Breyta stærð neðst til hægri`,
'sdcc2555c5dde524f': `Ertu viss um að þú viljir eyða þessum atriði? Ekki er hægt að afturkalla þessa aðgerð.`,
'se206feec7ec57b28': `í hverjum 100 g`,
'se419a9ab36987490': `Ógilda`,
'se5127cf0f92e7e48': `Ráð: þú getur líka fundið`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Ég mun leggja til betri uppskeru`,
'seea3800e27baa686': `Einstakar vörur`,
'sefaba4adc4ec9219': `Fasteignir þjóðfræðinnar`,
'seffa8ca49175b5f0': `Sérsniðnir eiginleikar`,
'sf44a6b3b232c28ea': str`Skiptu út núverandi gildi fyrir ${0}`,
'sf4cd86a2f5ef2588': `Strikamerki vöru`,
'sf57a61152168cc81': `Hjálpaðu okkur að leiðrétta innihaldsefnagreininguna`,
'sf88b90b8ba23871c': `Óþekkt samsvörun`,
'sf9aee319a006c9b4': `Bæta við`,
'sfacbbe968fa7d773': `Nafn eignar:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Samsvarandi gildi`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  